import React, { Component, PropTypes } from 'react';
import SorterSelect from 'common/sorter/components/select';
import Filter from 'common/filter/containers';
import ViewTypeSelector from 'common/components/entry_gallery/view_type_selector';
import GroupingSelector from 'common/components/entry_gallery/grouping_selector';
import { TYPE_CHECKBOXES } from 'common/filter/constants';
import {
  getSortingOptions, SCORE_OPTIONS, ELIMINATED_OPTIONS, WITHDRAWN_OPTIONS, ENTRIES_RESOURCE_NAME,
  NEW_OPTIONS
} from 'entries/constants';

const Controls = ({
  project, viewType, grouped, setViewType, setGrouping, atYourEntries, canViewRating, canViewNewTag,
  skipQuerySave
}) => {

  if (!project.id) {
    return null;
  }

  const sortingOptions = getSortingOptions(project.entry_type, canViewRating);

  return (
    <div className="project-gallery-controls sidebar sidebar-filter">
      <ViewTypeSelector entryType={project.entry_type} viewType={viewType}
        onChange={setViewType} />
      <GroupingSelector entryType={project.entry_type} grouped={grouped}
        onChange={setGrouping} />
      <div className="controls-group">
        <h5 className="sorting-name">Sort</h5>
        <SorterSelect resourceName={ENTRIES_RESOURCE_NAME} options={sortingOptions}
          defaultValue="-created_at" />
      </div>
      <div className="controls-group">
        <h5 className="sorting-name">Filters</h5>
        { canViewRating &&
        <Filter field="score" type={TYPE_CHECKBOXES} resourceName={ENTRIES_RESOURCE_NAME}
          options={SCORE_OPTIONS} skipQuerySave={skipQuerySave} /> }
        { canViewNewTag &&
        <Filter field="new" type={TYPE_CHECKBOXES} resourceName={ENTRIES_RESOURCE_NAME}
          options={NEW_OPTIONS} skipQuerySave={skipQuerySave} /> }
        <Filter field="entry_eliminated" type={TYPE_CHECKBOXES} resourceName={ENTRIES_RESOURCE_NAME}
          options={ELIMINATED_OPTIONS} skipQuerySave={skipQuerySave} />
        <Filter field="entry_withdrawn" type={TYPE_CHECKBOXES} options={WITHDRAWN_OPTIONS}
          resourceName={ENTRIES_RESOURCE_NAME} skipQuerySave={skipQuerySave} />
      </div>
    </div>
  );
}

Controls.propTypes = {
  project: PropTypes.object.isRequired,
  viewType: PropTypes.string,
  grouped: PropTypes.bool,
  atYourEntries: PropTypes.bool.isRequired,
  setViewType: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
  canViewRating: PropTypes.bool.isRequired,
  canViewNewTag: PropTypes.bool.isRequired,
  skipQuerySave: PropTypes.bool,
};

export default Controls;



// WEBPACK FOOTER //
// ./entries/components/controls.jsx